import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/AdminDashboard";
import DispatcherConsole from "@/pages/DispatcherConsole";
import DriverApp from "@/pages/DriverApp";
import Reports from "@/pages/Reports";
import History from "@/pages/History";
import Clients from "@/pages/Clients";
import Appointments from "@/pages/Appointments";

const ROLES_ADMIN = ["admin"];
const ROLES_DISPATCH = ["admin", "dispatcher"];
const ROLES_OPERATOR = ["operator"];

function RoleHome() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="p-8 text-muted-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  if (user.role === "dispatcher") return <Navigate to="/dispatch" replace />;
  return <Navigate to="/driver" replace />;
}

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <div className="p-8 text-muted-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App bg-background text-foreground min-h-screen">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Protected roles={ROLES_ADMIN}><AdminDashboard /></Protected>} />
            <Route path="/dispatch" element={<Protected roles={ROLES_DISPATCH}><DispatcherConsole /></Protected>} />
            <Route path="/reports" element={<Protected roles={ROLES_DISPATCH}><Reports /></Protected>} />
            <Route path="/history" element={<Protected roles={ROLES_DISPATCH}><History /></Protected>} />
            <Route path="/clients" element={<Protected roles={ROLES_DISPATCH}><Clients /></Protected>} />
            <Route path="/appointments" element={<Protected roles={ROLES_DISPATCH}><Appointments /></Protected>} />
            <Route path="/driver" element={<Protected roles={ROLES_OPERATOR}><DriverApp /></Protected>} />
            <Route path="/" element={<RoleHome />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" richColors position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
